import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';

import {ExcelDownloadButton} from 'src/modules/downloads/components/excel-download-button';
import {DOWNLOADS_PLACEHOLDER_ID} from 'src/modules/downloads/constants';

type Props = {
    onDownload: () => void,
};

export const Download = ({onDownload}: Props) => {
    const [portalHolder, setPortalHolder] = useState(document.getElementById(DOWNLOADS_PLACEHOLDER_ID));

    useEffect(() => {
        if (!portalHolder) {
            setPortalHolder(document.getElementById(DOWNLOADS_PLACEHOLDER_ID));
        }
    }, [portalHolder]);

    if (portalHolder) {
        const button = (
            <ExcelDownloadButton onDownload={onDownload}/>
        );

        return createPortal(button, portalHolder);
    }

    return null;
};
